module.exports = __webpack_public_path__ + "media/notice5.941869c7.mp3";